import { useState } from "react";
import { useLocation } from "@tanstack/react-router";
import { Button } from "@/components/ui/button";
import { Scale, Menu, X } from "lucide-react";
import Logo from "@/assets/logo.png";

export function Header({ onCta }: { onCta: () => void }) {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  
  const links = [
    { label: "Startseite", href: "#top" },
    { label: "Leistungen", href: "#leistungen" },
    { label: "Über uns", href: "#team" },
  ];

  const handleAnchorClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    const isHomePage = location.pathname === "/";
    
    if (!isHomePage) {
      e.preventDefault();
      window.location.href = "/" + href;
    }
  };

  const handleLogoClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    const isHomePage = location.pathname === "/";
    
    if (!isHomePage) {
      e.preventDefault();
      window.location.href = "/";
    }
  };

  return (
    <header className="sticky top-0 z-40 w-full border-b border-border/60 bg-background/85 backdrop-blur supports-[backdrop-filter]:bg-background/70">
      <div className="mx-auto flex h-20 max-w-7xl items-center justify-between px-4 md:px-6">
        <a href="#top" onClick={handleLogoClick} className="flex items-center gap-2">
          {/* <Scale className="h-6 w-6 text-navy" strokeWidth={2.2} />
          <span className="text-lg font-bold tracking-wide text-navy">VERITAS</span> */}
          <img src={Logo} alt="Veritas Logo" className="h-16 w-auto" />
        </a>
        <nav className="hidden items-center gap-8 md:flex">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={(e) => handleAnchorClick(e, l.href)}
              className="text-sm font-medium text-foreground/80 transition-colors hover:text-gold"
            >
              {l.label}
            </a>
          ))}
          <Button variant="navy" size="sm" onClick={onCta}>
            Kostenlose Erstberatung
          </Button>
        </nav>
        <button
          className="md:hidden"
          onClick={() => setOpen((v) => !v)}
          aria-label="Menü"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>
      {open && (
        <div className="border-t border-border bg-background md:hidden">
          <div className="mx-auto flex max-w-7xl flex-col gap-3 px-4 py-4">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={(e) => {
                  handleAnchorClick(e, l.href);
                  setOpen(false);
                }}
                className="py-1 text-sm font-medium text-foreground/80"
              >
                {l.label}
              </a>
            ))}
            <Button variant="navy" onClick={() => { setOpen(false); onCta(); }}>
              Kostenlose Erstberatung
            </Button>
          </div>
        </div>
      )}
    </header>
  );
}